export const NAME = "page-login";

export const LOGIN_FORM = `${NAME}/LOGIN_FORM`;
export const RESET_PASSWORD_FORM = `${NAME}/RESET_PASSWORD_FORM`;

export const LOGIN_PAGE_STEP = {
    LOGIN_FORM: `${NAME}/LOGIN_FORM`,
    RESET_PASSWORD: `${NAME}/RESET_PASSWORD`,
};
